import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import ViewPage from '../../Components/ViewPage';
import GalleryCard from '../../Components/GalleryCard';
import sections from './sections';

function Analytics({
  toggleDrawer,
}) {
  const { t } = useTranslation();
  return (
    <ViewPage title={t('Views.analyticsTitle')} toggleDrawer={toggleDrawer}>
      <Box
        data-testid="Analytics-View-Container"
        sx={{
          display: 'flex',
          flex: 1,
          flexWrap: 'wrap',
        }}
      >
        {sections(t).map((section) => (
          <GalleryCard
            key={section?.route}
            title={section?.title}
            route={section?.route}
            description={section?.description}
            icon={section?.icon}
          />
        ))}
      </Box>
    </ViewPage>
  );
}

Analytics.propTypes = {
  toggleDrawer: PropTypes.func,
};

Analytics.defaultProps = {
  toggleDrawer: () => {
    // Default
  },
};

export default Analytics;
